<div class="item-holder">

  <div *ngIf="loaded">
    <div class="listing-image-wrapper" (click)="goEditMode($event)"
      [attr.data-cy]="'listingItem-' + listing.address.title + '-img'">
      <ion-img class="user-image" [src]="propertyImage" *ngIf="hasPropertyImage && propertyImage"></ion-img>
      <img class="user-image" [src]="listing?.address.title | mapUrl"
        *ngIf="!hasPropertyImage && listing.address.placeId">
      <app-text-avatar *ngIf="!listing.hasPropertyImage && !listing.address.placeId" [avatarName]="listing.avatarName"
        [avatarColor]="listing.color"></app-text-avatar>
    </div>
    <!-- <div class="listing-date" [attr.data-cy]="'listingItem-' + listing.address.title + '-creationDate'">
      Added {{listing.createdAt | momentFormat:'MM-DD-YY'}}
    </div> -->
  </div>

  <div *ngIf="!loaded" class="listing-image-wrapper">
    <ion-skeleton-text animated style="height:96px; width:128px;"></ion-skeleton-text>
  </div>
  <div class="listing-body" #listingBody>
    <ion-row>
      <ion-col size="12">

        <div class="titleWrapper">
          <div class="listing-title" [attr.data-cy]="'listingItem-' + listing.address.title + '-title'">
            {{listing.address.title}}
          </div>

          <div class="listing-title-hgt pc-lnk">
            <div class="listingShareIcons" [ngClass]="listing.webPublished ? '' : 'faded'">
              <ion-button size="small" fill="clear" (click)="saveQR($event)" title="Save QR Code">
                <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="qr-code-outline"></ion-icon>
              </ion-button>
              <ion-button size="small" fill="clear" (click)="share('share',$event)" title="Share">
                <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="share-social-outline"></ion-icon>
              </ion-button>
              <ion-button size="small" fill="clear" class="cpy-lnk-marg " ion-button title="Open Link"
                (click)="openSlugLink(listing,$event)">
                <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="link-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>

      </ion-col>


      <ion-col size="12">
        <div class="listing-guests">
          <div *ngIf="openHouseEvents?.length" style="margin-bottom: 7px">
            <ion-chip
              class="open-house-time-chip chips"
              (click)="onChipClick($event)"
              [style.backgroundColor]="openHouseEvents[0].backgroundColor"
            >
              <ion-icon name="checkmark-circle-outline" />
              <ion-label>
                <!-- Single time slot vs multiple time slots -->
                {{
                  openHouseEvents.length === 1
                    ? openHouseEvents[0].extendedProps.formattedShortDate
                    : openHouseEvents.length + " Open Houses Assigned"
                }}</ion-label
              >
            </ion-chip>
          </div>
          <div class="guests-items" *ngIf="listing.guests.length > 0" tappable (click)="goToMyGuests($event)"
            [attr.data-cy]="'listingItem-listingGuests-' + listing.address.title + '-guestItems'">
            <div *ngFor="let guest of listing.guests; let index = index" class="avatar-holder"
              [class.hidden]="index>=maxGuestCount">
              <app-guest-item *ngIf="!guest.archived" [guest]="guest"></app-guest-item>
            </div>
            <div class="more-avatar-holder">
              <span class="more-avatar" [style.background-color]="countColor"
                [style.font-size.px]="listing.guestsCount - maxGuestCount > 99 ? '10' : '13'"
                *ngIf="listing.guests.length > maxGuestCount">
                +{{listing.guests.length - maxGuestCount}}
              </span>
            </div>
          </div>
          <div class="no-guests" *ngIf="listing.guests.length === 0"
            [attr.data-cy]="'listingItem-listingGuests-' + listing.address.title + '-noGuests'">
            <div class="icon-wrapper">
              <ion-icon name="close-circle-outline" [style.color]="'white'"></ion-icon>
            </div>
            <span>No leads</span>
          </div>
        </div>
      </ion-col>

      <div class="listing-date" [attr.data-cy]="'listingItem-' + listing.address.title + '-creationDate'">
        Added {{listing.createdAt | momentFormat:'MM-DD-YY'}} by {{addedByUserText}}
      </div>
    </ion-row>


  </div>
  <div class="listing-controls">
    <ion-button class="pc-lnk" size="small" fill="clear" (click)="presentPopover('desktop', $event)"
      [attr.data-cy]="'listingItem-' + listing.address.title + '-editBtn'" ion-button>
      <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
    </ion-button>

    <ion-button class="mobile-lnk" size="small" fill="clear" (click)="presentPopover('mobile', $event)"
      [attr.data-cy]="'listingItem-' + listing.address.title + '-editBtn'">
      <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
    </ion-button>

    <!--
<div (click)="goToOpenHouseMode($event)" class="button button-md">Launch
  </div>
  -->

    <!-- <div class="footer" (click)="goToMyGuests(listing.id)"></div> -->
  </div>
</div>

<!-- <ion-footer class="mob-link">
  <ion-button fill="clear" (click)="share('share',$event)">
    <ion-icon class="cpy-lnk  mob-cpy" src='assets/imgs/share-icon.svg'></ion-icon>
  </ion-button>
  <ion-button fill="clear" class="cpy-lnk-marg " (click)="openSlugLink(listing,$event)">
    <ion-icon class="cpy-lnk mob-cpy" src='assets/imgs/link-icon.svg'></ion-icon>
  </ion-button>
</ion-footer> -->